const closeOuter = (clicked: HTMLElement, wrapClass: string, oparator = '.') => {
  const wrap = clicked.closest(`${oparator}${wrapClass}`);

  if (clicked.classList.contains(wrapClass) || wrap) {
    return false;
  }

  return true;
};

export default closeOuter;
